// import 'core-js/es6/array';
// import 'core-js/es6/object';
// import 'core-js/es6/promise';
// import 'core-js/es6/map';
// import 'core-js/es6/set';
// import 'core-js/es6/string';
import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';

import React from 'react';
import ReactDOM from 'react-dom';
import { Router } from 'react-router-dom';
import { ConnectedRouter } from 'connected-react-router';
import { Provider } from 'react-redux';

import 'bootstrap/dist/css/bootstrap-grid.css';
import './index.css';

import App from './containers/App';
import { history, store } from './store';

if (process.env.NODE_ENV !== 'production') {
  var axe = require('react-axe');
  axe(React, ReactDOM, 1000);
}

ReactDOM.render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <Router history={history}>
        <App />
      </Router>
    </ConnectedRouter>
  </Provider>,
  document.getElementById('root'),
);
